/**
 * LO Transfer API wrapper
 *
 * POST /api/v1/lo-transfer-assets - Transfer all assets from one LO to another
 * POST /api/v1/lo-transfer-brand - Move an LO to a new brand
 */

import { api } from "../common/utils"
import {
  LO_TRANSFER_ASSETS_ENDPOINT,
  LO_TRANSFER_BRAND_ENDPOINT
} from "../common/constants"

export interface TransferAssetsPayload {
  from_loid: number
  to_loid: number
}

export interface TransferAssetsResponse {
  status: string
  message: string
  from_loid: number
  to_loid: number
  brand_id: number
}

export interface TransferBrandPayload {
  loid: number
  new_brand_id: number
}

export interface TransferBrandResponse {
  status: string
  message: string
  loid: number
  old_brand_id: number
  new_brand_id: number
}

const loTransfer = {
  transferAssets: async (
    payload: TransferAssetsPayload
  ): Promise<TransferAssetsResponse> => {
    if (!payload.from_loid) {
      throw new Error("from_loid is required")
    }
    if (!payload.to_loid) {
      throw new Error("to_loid is required")
    }
    if (payload.from_loid === payload.to_loid) {
      throw new Error("from_loid and to_loid cannot be the same")
    }

    const { data } = await api.post(LO_TRANSFER_ASSETS_ENDPOINT, payload)
    return data
  },

  transferBrand: async (
    payload: TransferBrandPayload
  ): Promise<TransferBrandResponse> => {
    if (!payload.loid) {
      throw new Error("loid is required")
    }
    if (!payload.new_brand_id) {
      throw new Error("new_brand_id is required")
    }

    const { data } = await api.post(LO_TRANSFER_BRAND_ENDPOINT, payload)
    return data
  }
}

export default loTransfer
